<img (click)="togglePannelVisibility()" class="filter-icon" src="../../../assets/icons/filter.svg" alt="Filter">
<div *ngIf="isPannelVisible" class="filter-pannel">
  <form [formGroup]="filterForm" class="form">
    <div *ngFor="let filter of filterConfig">
      <ng-container *ngIf="filter.type == 'multiple' ||  filter.type == 'single'">
        <mat-label>{{ filter.label }}</mat-label>
        <br>

        <mat-form-field class="width-100">
          <mat-select [formControlName]="filter.label" [multiple]="filter.type === 'multiple'"
            [placeholder]="'Select ' + filter.label">

            <!-- Search Field -->
            <mat-option>
              <ngx-mat-select-search [formControl]="searchControls[filter.label]" placeholderLabel="Search..."
                noEntriesFoundLabel="No results found" (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()">
              </ngx-mat-select-search>
            </mat-option>

            <!-- Select All Checkbox -->
            <mat-option class="g-select-all" (click)="toggleSelectAll(filter, $event)">
              <mat-checkbox [checked]="isAllSelected(filter)" [indeterminate]="isIndeterminate(filter)">
                Select All
              </mat-checkbox>
            </mat-option>

            <!-- All Options -->
            <mat-option *ngFor="let option of getFilteredOptions(filter)" [value]="option.value">
              {{ option.key }}
            </mat-option>

          </mat-select>
        </mat-form-field>

      </ng-container>
    </div>

    <div class="actions">
      <button class="btn secondary medium" (click)="cancel()">Cancel</button>
      <button class="btn primary medium" (click)="apply()">Apply</button>
    </div>
  </form>

</div>